import { render, staticRenderFns } from "./TeamUserAssigner.vue?vue&type=template&id=e58c24dc&scoped=true&lang=pug&"
import script from "./TeamUserAssigner.vue?vue&type=script&lang=js&"
export * from "./TeamUserAssigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58c24dc",
  null
  
)

export default component.exports